import React from "react";

export default function Sidebar() {
  return (
    <div className="container mx-auto font-serif bg-bgImage text-6xl font-bold text-green tracking-normal items-center flex justify-center ">
      My Blog
    </div>
  );
}
